import React, { useEffect, useState } from 'react'
import { Breadcrumb, Row, Col, Card, Form, Button } from 'react-bootstrap'
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import Layout from '../../layout/Layout'
import { API } from '../../App';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie'

const TopFundDetailAdd = () => {

  const tokenAuth = async () => {
    const token = Cookies.get('jwt')
    const response = await API.post("/home", {}, { headers: { "Authorization": `Bearer ${token}` } })
    if (response.data.status === false) {
      navigate("/")
    }
  }
  const [validate,setValidate] = useState(false)
  const navigate = useNavigate()
  const [data, setData] = useState([])
  const [fund, setFund] = useState([])
  const getData = async () => {
    const token = Cookies.get('jwt')
    const response = await API.post("/amc/company/list", {}, { headers: { "Authorization": `Bearer ${token}` } })
    if (response.data.status === false) {
      if (response.data.response_code === 429) {
        navigate("/")
      } else {
        toast.error('something went wrong in Amc Company List', { appearance: "error" })
      }
    } else {
      setData(response.data.data.data)
    }
  }

  const [status, setStatus] = useState(1)
  const [inpData, setInpData] = useState({
    Company: "",
    Fund: "",
    FundName: "",
    Category: "",
    Rating: "",
    Return1: "",
    Risk: "",
    Nav: "",
    MiniSip: "",
    ExpRatio: "",
    FundSize: "",
    SID: "",
    Pros: "",
    Loss: "",
    TaxImp: "",
    Address: "",
    InvObj: "",
    Min1: "",
    Min2: "",
    Phone: "",
    Website: "",
    Custodian: "",
    Agent: "",
    AgentWeb: "",
    AgentAdd: "",
    AgentEmail: ""
  })

  const getValue = async (e) => {
    setInpData({ ...inpData, [e.target.name]: e.target.value })
    if (e.target.name === "Company") {
      if (e.target.value !== "") {
        const Form = new FormData
        Form.append("company", e.target.value)
        const token = Cookies.get('jwt')
        const response = await API.post("/amc/fundlist/by/company", Form, {}, { headers: { "Authorization": `Bearer ${token}` } })
        if (response.data.status === true) {
          setFund(response.data.data)
        } else {
          if (response.data.response_code === 429) {
            navigate("/")
          } else {
            setFund([])
          }
        }
      } else {
        setFund([])
      }
    }
  }

  //Returns
  const [returns, setReturns] = useState([{
    name: "",
    oneY: "",
    threeY: "",
    fiveY: "",
    allTime: ""
  }])
  const addReturn = (tag1, name) => {
    const returnTag = {
      name: "",
      oneY: "",
      threeY: "",
      fiveY: "",
      allTime: ""
    }
    setReturns([...returns, returnTag])
  }

  const removeReturn = (index, id) => {
    const data = [...returns]
    data.splice(index, 1)
    setReturns(data)
  }

  const returnChange = (e, index) => {
    let data = [...returns];
    data[index][e.target.name] = e.target.value
    setReturns(data)
  }

  //Holdings
  const [holdings, setHoldings] = useState([{
    url: "",
    name: "",
    sector: "",
    instrument: "",
    assets: ""
  }])
  const addHoldings = (tag1, name) => {
    const holdingTag = {
      url: "",
      name: "",
      sector: "",
      instrument: "",
      assets: ""
    }
    setHoldings([...holdings, holdingTag])
  }

  const removeHolding = (index, id) => {
    const data = [...holdings]
    data.splice(index, 1)
    setHoldings(data)
  }

  const holdingChange = (e, index) => {
    let data = [...holdings];
    data[index][e.target.name] = e.target.value
    setHoldings(data)
  }

  //Fund Managers
  const [manager, setManager] = useState([{
    name: "",
    education: "",
    experiance: "",
    managedList: [{
      schemeName: "",
      url: ""
    }]
  }])
  const addManager = (tag1, name) => {
    const returnTag = {
      name: "",
      education: "",
      experiance: "",
      managedList: [{
        schemeName: "",
        url: ""
      }]
    }
    setManager([...manager, returnTag])
  }

  const removeManager = (index, id) => {
    const data = [...manager]
    data.splice(index, 1)
    setManager(data)
  }

  const managerChange = (e, index) => {
    let data = [...manager];
    data[index][e.target.name] = e.target.value
    setManager(data)
  }

  const listChange = (e, ind, index) => {
    let data = [...manager];
    data[ind].managedList[index][e.target.name] = e.target.value
    setManager(data)
  }

  const addList = (ind) => {
    let data = [...manager]
    data[ind].managedList.push({
      schemeName: "",
      url: ""
    })
    setManager(data)
  }

  const removeList = (ind, index) => {
    let data = [...manager];
    data[ind].managedList.splice(index, 1)
    setManager(data)
  }

  useEffect(() => {
    tokenAuth()
    getData()
  }, [])

  const saveData = async () => {
    if (inpData.Company === "" || inpData.Fund === "" || inpData.FundName === "" || inpData.Category === "" || inpData.Rating === "" || inpData.Return1 === "" ||
      inpData.Risk === "" || inpData.Nav === "" || inpData.MiniSip === "" || inpData.ExpRatio === "" || inpData.FundSize === "" || inpData.SID === "" ||
      inpData.Pros === "" || inpData.Loss === "" || inpData.TaxImp === "" || inpData.Address === "" || inpData.InvObj === "" || inpData.Min1 === "" ||
      inpData.Min2 === "" || inpData.Phone === "" || inpData.Website === "" || inpData.Custodian === "" || inpData.Agent === "" || inpData.AgentWeb === "" ||
      inpData.AgentAdd === "" || inpData.AgentEmail === "") {
        setValidate(true)
      
    } else {
      let returnCounter = 0
      returns.map((returnVal) => {
        if (returnVal.name === "" || returnVal.oneY === "" || returnVal.threeY === "" || returnVal.fiveY === "" || returnVal.allTime === "") {
          returnCounter++
        }
      })
      if (returnCounter === 0) {
        let holdingCounter = 0
        holdings.map((holdingsVal) => {
          if (holdingsVal.url === "" || holdingsVal.name === "" || holdingsVal.sector === "" || holdingsVal.instrument === "" || holdingsVal.assets === "") {
            holdingCounter++
          }
        })
        if (holdingCounter === 0) {
          let managerCount = 0
          manager.map((managerVal) => {
            if (managerVal.name === "" || managerVal.education === "" || managerVal.experiance === "") {
              managerCount++
            }
            managerVal.managedList.map((listVal) => {
              if (listVal.schemeName === "" || listVal.url === "") {
                managerCount++
              }
            })
          })
          if (managerCount === 0) {
            const Form = new FormData()
            Form.append('companyid', inpData.Company)
            Form.append('fundid', inpData.Fund)
            Form.append('fundname', inpData.FundName)
            Form.append('category', inpData.Category)
            Form.append('rating', inpData.Rating)
            Form.append('return1', inpData.Return1)
            Form.append('risk', inpData.Risk)
            Form.append('nav', inpData.Nav)
            Form.append('minisip', inpData.MiniSip)
            Form.append('expratio', inpData.ExpRatio)
            Form.append('fundsize', inpData.FundSize)
            Form.append('pros', inpData.Pros)
            Form.append('loss', inpData.Loss)
            Form.append('sid', inpData.SID)
            Form.append('invobj', inpData.InvObj)
            Form.append('taximp', inpData.TaxImp)
            Form.append('min1', inpData.Min1)
            Form.append('min2', inpData.Min2)
            Form.append('address', inpData.Address)
            Form.append('phone', inpData.Phone)
            Form.append('website', inpData.Website)
            Form.append('custodian', inpData.Custodian)
            Form.append('agent', inpData.Agent)
            Form.append('agentadd', inpData.AgentAdd)
            Form.append('agentmail', inpData.AgentEmail)
            Form.append('agentweb', inpData.AgentWeb)
            Form.append('return', JSON.stringify(returns))
            Form.append('holdings', JSON.stringify(holdings))
            Form.append('fundmanager', JSON.stringify(manager))
            Form.append('status', status)
            const token = Cookies.get('jwt')
            const response = await API.post("/add/amc/fund/detail", Form, { headers: { "Authorization": `Bearer ${token}` } })
            console.log(response);
            if (response.data.status === true) {
              toast.success("Top Fund Detail added succesfully")
              navigate("/funddetail")
            } else {
              if (response.data.response_code === 429) {
                navigate("/")
              } else {
                toast.error('something went wrongg')
              }
            }
          } else {
            // addToast("all fields of Fund Manager Data  are required", { appearance: "warning" })
            setValidate(true)
          }
        } else {
          // addToast("all fields in Fund Holdings are required", { appearance: "warning" })
          setValidate(true)
        }
      } else {
        // addToast("all fields in Fund Returns are required", { appearance: "warning" })
        setValidate(true)
      }
    }
  }

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3>Add Top Fund Detail</h3>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/"><i className='bx bx-home-alt me-2 fs-5' ></i> Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/funddetail">Top Fund Detail List</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Add New Top Fund Detail</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="page-content">
      <Form noValidate validated={validate}>
        <Row>
          <Col xs={12}>
            <Card>
              <Card.Body>
                {/* 1 */}
                <Row>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='state-name'>Company Name</Form.Label>
                      <Form.Select id="state-name" className="my-2" name='Company' onChange={(e) => { getValue(e) }} required>
                        <option value="">Select Company</option>
                        {
                          data.map((dataVal, ind) => {
                            return (
                              <option value={dataVal._id} key={ind}>{dataVal.name}</option>
                            )
                          })
                        }
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='top-fund'>Top Fund</Form.Label>
                      <Form.Select id="top-fund" className="my-2" name='Fund' onChange={(e) => { getValue(e) }} required>
                        <option value="">Select Fund Name</option>
                        {
                          fund.map((dataVal, ind) => {
                            return (
                              <option value={dataVal._id} key={ind}>{dataVal.fundName}</option>
                            )
                          })
                        }
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='fund-name'>Fund Name</Form.Label>
                      <Form.Control type="text" className="my-2" id='fund-name' name='FundName' value={inpData.FundName} onChange={(e) => { getValue(e) }} placeholder="Enter Your Fund Name" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='cat-name'>Category</Form.Label>
                      <Form.Control type="text" className="my-2" id='cat-name' name='Category' value={inpData.Category} onChange={(e) => { getValue(e) }} placeholder="Enter Your Category" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='rating'>Rating</Form.Label>
                      <Form.Control type="text" className="my-2" id='rating' name='Rating' value={inpData.Rating} onChange={(e) => { getValue(e) }} placeholder="Enter Your Rating" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='return-1'>Return 1Y</Form.Label>
                      <Form.Control type="text" className="my-2" id='return-1' name='Return1' value={inpData.Return1} onChange={(e) => { getValue(e) }} placeholder="Enter Your Return One Year" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='risk'>Risk</Form.Label>
                      <Form.Control type="text" className="my-2" id='risk' name='Risk' value={inpData.Risk} onChange={(e) => { getValue(e) }} placeholder="Enter Your Risk" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='nav'>Nav</Form.Label>
                      <Form.Control type="text" className="my-2" id='nav' name='Nav' value={inpData.Nav} onChange={(e) => { getValue(e) }} placeholder="Enter Your Nav" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='miniSipAmt'>Mini Sip Amt</Form.Label>
                      <Form.Control type="text" className="my-2" id='miniSipAmt:' name='MiniSip' value={inpData.MiniSip} onChange={(e) => { getValue(e) }} placeholder="Enter Your Mini Sip Amt" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='expRatio'>Exp Ratio</Form.Label>
                      <Form.Control type="text" className="my-2" id='expRatio' name='ExpRatio' value={inpData.ExpRatio} onChange={(e) => { getValue(e) }} placeholder="Enter Your Exp Ratio" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='fundSize'>Fund Size</Form.Label>
                      <Form.Control type="text" className="my-2" id='fundSize' name='FundSize' value={inpData.FundSize} onChange={(e) => { getValue(e) }} placeholder="Enter Your Fund Size" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='sid'>Sid</Form.Label>
                      <Form.Control type="text" className="my-2" id='sid' name='SID' value={inpData.SID} onChange={(e) => { getValue(e) }} placeholder="Enter Your Sid" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='pros'>Pros</Form.Label>
                      <Form.Control as="textarea" rows={4} className="my-2" id='pros' name='Pros' value={inpData.Pros} onChange={(e) => { getValue(e) }} placeholder="Enter Your Pros" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='loss'>Loss</Form.Label>
                      <Form.Control as="textarea" rows={4} className="my-2" id='loss' name='Loss' value={inpData.Loss} onChange={(e) => { getValue(e) }} placeholder="Enter Your Loss" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='taxImp'>Tax Imp</Form.Label>
                      <Form.Control as="textarea" rows={4} className="my-2" id='taxImp' name='TaxImp' value={inpData.TaxImp} onChange={(e) => { getValue(e) }} placeholder="Enter Your Tax Imp" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='address'>Address</Form.Label>
                      <Form.Control as="textarea" rows={4} className="my-2" id='address' name='Address' value={inpData.Address} onChange={(e) => { getValue(e) }} placeholder="Enter Your Address" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='invObj'>Inv Obj</Form.Label>
                      <Form.Control type="text" className="my-2" id='invObj' name='InvObj' value={inpData.InvObj} onChange={(e) => { getValue(e) }} placeholder="Enter Your invObj" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='min1stInv'>Min 1st Inv</Form.Label>
                      <Form.Control type="text" className="my-2" id='min1stInv' name='Min1' value={inpData.Min1} onChange={(e) => { getValue(e) }} placeholder="Enter Your Min 1st Inv" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='min2ndInv'>Min 2nd Inv</Form.Label>
                      <Form.Control type="text" className="my-2" id='min2ndInv' name='Min2' value={inpData.Min2} onChange={(e) => { getValue(e) }} placeholder="Enter Your Min 2nd Inv" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='phone'>Phone</Form.Label>
                      <Form.Control type="number" className="my-2" id='phone' name='Phone' value={inpData.Phone} onChange={(e) => { getValue(e) }} placeholder="Enter Your Phone" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='web-url'>WebSite</Form.Label>
                      <Form.Control type="text" className="my-2 pe-5" id='web-url' name='Website' value={inpData.Website} onChange={(e) => { getValue(e) }} placeholder="Enter Your WebSite" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='custodian'>Custodian</Form.Label>
                      <Form.Control type="text" className="my-2" id='custodian' name='Custodian' value={inpData.Custodian} onChange={(e) => { getValue(e) }} placeholder="Enter Your Custodian" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='agent'>Agent</Form.Label>
                      <Form.Control type="text" className="my-2" id='agent' name='Agent' value={inpData.Agent} onChange={(e) => { getValue(e) }} placeholder="Enter Your Agent" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='a-url'>Agent Web</Form.Label>
                      <Form.Control type="text" className="my-2 pe-5" id='a-url' name='AgentWeb' value={inpData.AgentWeb} onChange={(e) => { getValue(e) }} placeholder="Enter Your Agent Web" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='agentAdd'>Agent Add</Form.Label>
                      <Form.Control as="textarea" rows={4} className="my-2" id='agentAdd' name='AgentAdd' value={inpData.AgentAdd} onChange={(e) => { getValue(e) }} placeholder="Enter Your Agent Add" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12}>
                    <Form.Group >
                      <Form.Label htmlFor='a-mail'>Agent Email</Form.Label>
                      <Form.Control as="textarea" rows={4} className="my-2" id='a-email' name='AgentEmail' value={inpData.AgentEmail} onChange={(e) => { getValue(e) }} placeholder="Enter Your Agent Email" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12} >
                    <Form.Group >
                      <Form.Label className="d-block mb-2" htmlFor='bank-status'>Status </Form.Label>
                      <BootstrapSwitchButton id="bank-status" checked={status === 1 ? true : false} onChange={(e) => { e === true ? setStatus(1) : setStatus(0) }} onlabel='Enable' offlabel='Disable' width={125} />
                    </Form.Group>
                  </Col>
                </Row>
                {/* 2. Return */}
                <Row className='mt-2'>
                  <Col sm={12}>
                    {
                      returns.map((returnVal, ind) => {
                        return (
                          <Row>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='r-name'>Return Name</Form.Label>
                                <Form.Control type="text" className="my-2" id='r-name' value={returnVal.name} name='name' onChange={(e) => { returnChange(e, ind) }} placeholder="Enter Your Name" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='oney'>Return One Year</Form.Label>
                                <Form.Control type="text" className="my-2" id='oney' value={returnVal.oneY} name='oneY' onChange={(e) => { returnChange(e, ind) }} placeholder="Enter Your One Year" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='five'>Return Five Year</Form.Label>
                                <Form.Control type="text" className="my-2" id='five' value={returnVal.threeY} name='threeY' onChange={(e) => { returnChange(e, ind) }} placeholder="Enter Your Five Year" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='threey'>Return Three Year</Form.Label>
                                <Form.Control type="text" className="my-2" id='threey' value={returnVal.fiveY} name='fiveY' onChange={(e) => { returnChange(e, ind) }} placeholder="Enter Your Three Year" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='alltime'>Return All Time</Form.Label>
                                <Form.Control type="text" className="my-2" id='alltime' value={returnVal.allTime} name='allTime' onChange={(e) => { returnChange(e, ind) }} placeholder="Enter Your All Time" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12} className="align-self-end my-2">
                              {
                                ind === 0 ? <Button variant="primary" size="sm" className="btn-icon" onClick={addReturn}><i class='bx bx-plus'></i></Button> :
                                  <Button variant="danger" size="sm" className="btn-icon" onClick={() => { removeReturn(ind) }}><i class='bx bx-x' ></i></Button>
                              }
                            </Col>
                          </Row>
                        )
                      })
                    }
                  </Col>

                </Row>
                {/* 3. Holdings */}
                <Row>
                  <Col sm={12}>
                    {
                      holdings.map((holdingVal, ind) => {
                        return (
                          <Row>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='h-url'>Holdings URL</Form.Label>
                                <Form.Control type="text" className="my-2" id='r-name' value={holdingVal.url} name='url' onChange={(e) => { holdingChange(e, ind) }} placeholder="Enter Your URL" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='h-name'>Holdings Name</Form.Label>
                                <Form.Control type="text" className="my-2" id='h-name' value={holdingVal.name} name='name' onChange={(e) => { holdingChange(e, ind) }} placeholder="Enter Your Name" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='h-sector'>Holdings Sector</Form.Label>
                                <Form.Control type="text" className="my-2" id='h-sector' value={holdingVal.sector} name='sector' onChange={(e) => { holdingChange(e, ind) }} placeholder="Enter Your Sector" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='h-instrument'>Holdings Instrument</Form.Label>
                                <Form.Control type="text" className="my-2" id='h-instrument' value={holdingVal.instrument} name='instrument' onChange={(e) => { holdingChange(e, ind) }} placeholder="Enter Your Instrument" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='h-assets'>Holdings Assets</Form.Label>
                                <Form.Control type="text" className="my-2" id='h-assets' value={holdingVal.assets} name='assets' onChange={(e) => { holdingChange(e, ind) }} placeholder="Enter Your Assets" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12} className="align-self-end my-2">
                              {
                                ind === 0 ? <Button variant="primary" size="sm" className="btn-icon" onClick={addHoldings}><i class='bx bx-plus'></i></Button> :
                                  <Button variant="danger" size="sm" className="btn-icon" onClick={() => { removeHolding(ind) }}><i class='bx bx-x' ></i></Button>
                              }
                            </Col>
                          </Row>
                        )
                      })
                    }
                  </Col>
                </Row>
                {/* 4. Fund Manager */}
                <Row>
                  <Col sm={12}>
                    {
                      manager.map((managerVal, ind) => {
                        return (
                          <Row>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='fm-url'>Name</Form.Label>
                                <Form.Control type="url" className="my-2" id='fm-name' value={managerVal.name} name='name' onChange={(e) => { managerChange(e, ind) }} placeholder="Enter Your Name" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='h-edu'>Education</Form.Label>
                                <Form.Control type="text" className="my-2" id='h-edu' value={managerVal.education} name='education' onChange={(e) => { managerChange(e, ind) }} placeholder="Enter Your Education" required/>
                              </Form.Group>
                            </Col>
                            <Col lg={2} sm={12}>
                              <Form.Group >
                                <Form.Label htmlFor='fm-exp'>Experiance</Form.Label>
                                <Form.Control type="text" className="my-2" id='fm-exp' value={managerVal.experiance} name='experiance' onChange={(e) => { managerChange(e, ind) }} placeholder="Enter Your Experiance" required/>
                              </Form.Group>
                            </Col>
                            {/* Managed List */}
                            <Col lg={5} sm={12}>
                              {
                                managerVal.managedList.map((listVal, index) => {
                                  return (
                                    <Row>
                                      <Col lg={5} sm={12}>
                                        <Form.Group >
                                          <Form.Label htmlFor='ml-sname'>Scheme Name</Form.Label>
                                          <Form.Control type="text" className="my-2" id='ml-sname' value={listVal.schemeName} name='schemeName' onChange={(e) => { listChange(e, ind, index) }} placeholder="Enter Your Scheme Name" required/>
                                        </Form.Group>
                                      </Col>
                                      <Col lg={5} sm={12}>
                                        <Form.Group >
                                          <Form.Label htmlFor='ml-url'>URL</Form.Label>
                                          <Form.Control type="text" className="my-2" id='ml-url' value={listVal.url} name='url' onChange={(e) => { listChange(e, ind, index) }} placeholder="Enter Your URL" required/>
                                        </Form.Group>
                                      </Col>
                                      <Col lg={2} sm={12} className="align-self-end my-2">
                                        {
                                          index === 0 ? <Button variant="primary" size="sm" className="btn-icon" onClick={() => { addList(ind) }}><i class='bx bx-plus'></i></Button> :
                                            <Button variant="danger" size="sm" className="btn-icon" onClick={() => { removeList(ind, index) }}><i class='bx bx-x' ></i></Button>
                                        }
                                      </Col>
                                    </Row>
                                  )
                                })
                              }
                            </Col>
                            <Col lg={1} sm={12} className="my-2">
                              {
                                ind === 0 ? <Button variant="primary" size="sm" className="btn-icon m-t-30" onClick={addManager}><i class='bx bx-plus'></i></Button> :
                                  <Button variant="danger" size="sm" className="btn-icon m-t-30" onClick={() => { removeManager(ind) }}><i class='bx bx-x' ></i></Button>
                              }
                            </Col>
                          </Row>
                        )
                      })
                    }
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer className="text-end">
                <Button variant="primary" className="me-3" onClick={saveData} >Save</Button>
                <Link to="/funddetail">
                  <Button variant="secondary">Cancle</Button>
                </Link>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Form>
      </div>
    </Layout>
  )
}

export default TopFundDetailAdd